















































































import Vue from "vue"

interface Term {
  title: string
  articles: Array<{
    title: string
    rows: Array<{
      description: string
      rows?: Array<{
        description: string
      }>
    }>
  }>
}

export default Vue.extend({
  head() {
    return this.$clHelpers.metaTag.generate({
      title: "利用規約",
      currentPath: this.$nuxt.$route.path,
    })
  },
  computed: {
    revesionDateTexts(): string[] {
      return [
        "改訂日：2021年2月1日改訂",
        "　　　　2021年7月14日改訂",
        "　　　　2022年11月22日改訂",
        "　　　　2023年1月4日改訂",
        "　　　　2023年8月31日改訂",
      ]
    },
    terms(): Term[] {
      return [
        {
          title: "第１章　総則",
          articles: [
            {
              title: "第１条（利用規約の目的および適用）",
              rows: [
                {
                  description:
                    "１．クラウドリンクス利用規約（以下「本規約」という）は、株式会社クラウドワークス（以下「当社」という）が運営するクラウドリンクス（以下「本サイト」という）を通じて、当社が会員（次条で定義する）またはクライアントに対し有償または無償で提供する一切のサービスの受益者及び関係者に適用されます。",
                },
                {
                  description:
                    "２．会員は、会員登録の申し込みをした時点で、本規約の内容を完全に承諾し遵守することに同意しているものとみなされます。また、本規約の全部又は一部に承諾せずに会員登録の申込みをすることは一切できないものとし、不承諾の意思表示は、本サイトへの会員登録の申込みをしないことをもってのみ認められます。",
                },
              ],
            },
            {
              title: "第２条（定義）",
              rows: [
                {
                  description:
                    "(1)「本サービス」：本サイトを通じて、当社が会員に有償または無償で提供するサービスの総称とする。",
                },
                {
                  description:
                    "(2)「会員」：本規約に同意し、本サイトに必要な情報を登録した者であり、以下に定める者を含む。",
                  rows: [
                    {
                      description:
                        "ⅰ）「無料会員」：所定の方法で本サイトに登録することにより、利用料を支払うことなく、当社所定の範囲で利用する会員をいう。",
                    },
                    {
                      description:
                        "ⅱ）「有料会員」：無料会員の利用範囲を超えて本サービスの利用を希望する会員であって、当社所定の方法でなされた申込を当社が承諾することにより、本サービスに係る利用料を支払い、当社所定の範囲で利用する会員をいう。",
                    },
                  ],
                },
                {
                  description:
                    "(3)「相談者」：会員本人または所属する団体における課題解決のため、必要な情報を本サイトに投稿し、受託者を募集する者をいう。",
                },
                {
                  description:
                    "(4)「受託者」：会員本人の技能により相談者の課題解決を行うために、必要な情報を本サイトに登録および公開し、相談者の投稿に対して応募する者をいう。",
                },
                {
                  description:
                    "(5)「クライアント」：会員に限らず、当社と別途定める契約に基づき本サービスを利用する者をいう。",
                },
                {
                  description:
                    "(6)「利用者」：会員、クライアント、本サイトの閲覧をする者及び本アカウントの登録をした者をいう。",
                },
                {
                  description:
                    "(7)「有料期間」：有料会員としての本サイトの利用期間のうち、当該利用契約成立日の属する月の翌月１日から当社および会員の合意する期間が経過する日までとし、本サイトの利用に係る利用料が発生する期間をいう。",
                },
                {
                  description:
                    "(8)「マッチング」：双方において後に生ずる業務取引を行う意向が合致している状態をいう。",
                },
                {
                  description:
                    "(9)「業務取引」：相談者もしくはクライアントと受託者との間で、プロジェクトに係る雇用契約または業務委託契約等の契約を締結することをいう。",
                },
                {
                  description:
                    "(10)「メッセージ」：相談者と受託者が、本サービス内外のツールを用いて相互に連絡を行うことをいう。",
                },
                {
                  description:
                    "(11)「面談」：相談者またはクライアントと受託者が、対面方式（オンライン会議を含みます）でプロジェクト内容の確認、条件面を相談することをいう。",
                },
                {
                  description:
                    "(12)「応募」：受託しようとする会員が、プロジェクトの内容が掲載されているページにおいて、参加の意向を示すことをいう。",
                },
                {
                  description:
                    "(13)「スカウト」：相談しようとする会員が、プロフィールの内容が掲載されているページにおいて、参加してほしい意向を示すことをいう。",
                },
                {
                  description:
                    "(14)「プロフィール」：実名、写真を含む会員の登録情報をいう。",
                },
                {
                  description:
                    "(15)「プロジェクト」：相談者が案件としてお願いしたいこと、相談したい課題をいう。",
                },
                {
                  description:
                    "(16)「コーポレーション機能」：相談者が法人として利用場合において、同一法人内の別会員に関して、当該法人格として利用権利を与えるものをいう。",
                },
                {
                  description:
                    "(17)「本アカウント」：本サービスによるSNSアカウント（LINE公式アカウント及びX（旧Twitter）公式アカウント）をいう。",
                },
                {
                  description:
                    "(18)「本コンテンツ」：本アカウントが利用者に対して送信したコンテンツをいう。",
                },
              ],
            },
          ],
        },
        {
          title: "第２章　会員登録",
          articles: [
            {
              title: "第３条（無料会員登録）",
              rows: [
                {
                  description:
                    "１．無料会員となることを希望する個人または法人は、本規約に同意の上、当社が定める情報（個人情報保護法第２条に定める個人情報を含む。）を登録、送信することをもって無料会員として登録されるものとし、登録を以って、無料会員としての本サービスの利用契約が成立するものとします。なお、無料会員は、会員登録時から本サービスについて当社が定める範囲で利用することができるものとし、当該利用について本規約が適用されます。",
                },
                {
                  description:
                    "２．前項にかかわらず、無料会員として登録されるためには、以下の各号に定める条件をすべて満たす必要があります。ただし、当社が事前に承諾した場合はこの限りではありません。なお、複数人で構成された組織体単位での登録は一切不可となります（例：エンジニア数人で構成されたチーム）。",
                  rows: [
                    {
                      description: "(1) 満18歳以上であること",
                    },
                    {
                      description:
                        "(2) 学生（高校生、大学生、大学院生、専門学生）でないこと",
                    },
                    {
                      description:
                        "(3) プロフィール上に記載する業務について、実務経験 が2年以上あること",
                    },
                    {
                      description:
                        "(4) 法人の場合、一人会社であること（法人の代表者が業務実施者であること）",
                    },
                    {
                      description: "(5) 既に本サービスの会員となっていないこと",
                    },
                    {
                      description: "(6) 本規約の全ての条項に同意すること",
                    },
                    {
                      description:
                        "(7) 過去５年以内に、第２８条に定める暴力団等の反社会的勢力に所属せず、これらの者との関係を有していないこと",
                    },
                    {
                      description:
                        "(8) 日本または海外において適法に就労するための要件を満たしていること",
                    },
                    {
                      description:
                        "(9) 自己の所属する組織体の規則に反した行為をしていないこと",
                    },
                  ],
                },
                {
                  description:
                    "３．当社は、無料会員登録を希望する個人または法人が以下の各号の一に該当する場合は、会員として登録することを承諾しない場合があります。",
                  rows: [
                    {
                      description:
                        "(1) 前項に違反することが判明した場合、またはそのおそれがあると当社が認めた場合",
                    },
                    {
                      description:
                        "(2) 本人（法人の場合は代表者）以外の代理人による登録の申込みであることが判明した場合",
                    },
                    {
                      description:
                        "(3) その他当社が会員登録を不適切であると判断した場合",
                    },
                  ],
                },
                {
                  description:
                    "４．当社は、登録可否の判断にあたり所定の審査を行うことができるものとし、審査において必要な場合、無料会員登録を希望する個人または法人に対して追加の書類等の提出を求めることができるものとします。",
                },
                {
                  description:
                    "５．当社は、無料会員登録の申込者が会員として不適当と判断した場合には、その登録を拒否することができ、当社は登録の拒否について一切の責任を負わず、また登録を拒否する理由を申込者に説明する義務も負いません。また、申込者はこれらにつき異議を申し立てないものとします。",
                },
                {
                  description:
                    "６．前各項に掲げる審査および登録拒否によって生じる一切の損害について、当社は何らの責任も負わないものとします。",
                },
              ],
            },
            {
              title: "第４条（有料会員の審査および契約開始）",
              rows: [
                {
                  description:
                    "１．有料会員となることを希望する者は、本規約に同意の上、当社が定める情報（個人情報保護法第２条に定める個人情報を含む。）を登録、送信することをもって有料会員登録の申し込みをしたものとみなします。",
                },
                {
                  description:
                    "２．当社は、前項の申し込みについて所定の審査を行うものとし、審査において必要な場合、有料会員となることを希望する者に対し追加の書類等の提出を求めることができるものとします。",
                },
                {
                  description:
                    "３．当社は、有料会員登録を申し込んだ個人または法人（当該法人の担当者を含む）が有料会員として不適当と判断した場合には、その登録を拒否することができ、当社は登録の拒否について一切の責任を負わず、また登録を拒否する理由を申込者に説明する義務も負いません。また、申込者はこれらにつき異議を申し立てないものとします。",
                },
                {
                  description:
                    "４．前各項に掲げる審査及び登録拒否によって生じる一切の損害について、当社は何らの責任も負わないものとします。",
                },
                {
                  description:
                    "５．当社は、登録審査の結果、有料会員登録の申し込みを承諾する場合、当該会員の指定するアドレスに登録完了の通知を行うものとし、当該通知の送信を以って、本サービスの有料会員としての利用契約が成立します。なお、有料会員は、本サービスの有料会員としての利用契約の成立を以って、有料期間中の本サービスの利用料の支払い義務を負うものとし、第１５条に基づき当該利用料を支払うものとします。",
                },
              ],
            },
            {
              title: "第５条（登録情報の変更）",
              rows: [
                {
                  description:
                    "会員は、本サイトに登録した情報に変更が生じる場合、速やかに本サイト所定のページから登録情報を変更しなければなりません。",
                },
              ],
            },
          ],
        },
        {
          title: "第３章　サービスの利用",
          articles: [
            {
              title: "第６条（サービスの利用者）",
              rows: [
                {
                  description:
                    "本サービスの利用者は、会員ならびにクライアントおよびその担当者（事前に当社に本サービスを利用する者として通知をした者）に限ります。",
                },
              ],
            },
            {
              title: "第７条（事前承諾）",
              rows: [
                {
                  description:
                    "１．会員およびクライアントは、本サービスを利用するに当たり以下の各号に定める事由について事前に承諾したものとみなします。",
                  rows: [
                    {
                      description:
                        "(1)受託者本人により本サイト上に登録したプロフィールまたはそれに付随して合理的な範囲で入手可能な情報が相談者およびクライアントに共有される可能性が有ること",
                    },
                    {
                      description:
                        "(2)受託者と相談者またはクライアントとの面談において、受託者の事前の同意を得ることなく、相談者またはクライアントの関係者（当社に対して負担する守秘義務と同等の守秘義務を負担することに同意しており、かつ、事前に当社に開示された者に限られる）が参加する可能性があること",
                    },
                  ],
                },
                {
                  description:
                    "２．相談者およびクライアントは、受託者が企業等第三者(以下、「所属元企業」という)に雇用されている場合において、所属元企業が当該受託者の行為について何らの保証もしておらず、また責任を負わないことを確認し、かつ以下の各号に同意するものとします。",
                  rows: [
                    {
                      description:
                        "(1)受託者が提供する情報を含む成果物や本サービスにおける活動は、所属元企業を代表するものではなく、あくまでも個人としての見解であること",
                    },
                    {
                      description:
                        "(2)本サービスの利用に関連して生じた被害やクレーム等に対して、所属元企業は、一切の責任を負わないこと",
                    },
                    {
                      description:
                        "(3)相談者およびクライアントは所属元企業に対して、一切のクレームや要求を行わないこと",
                    },
                    {
                      description:
                        "(4)所属元企業は、受託者の行為や作成した成果物について、正確性・妥当性・有用性・適法性を確認及び保証せず、内容について瑕疵があった場合でも、責任を負わないこと",
                    },
                    {
                      description:
                        "(5)相談者およびクライアントは、所属元企業に対して、受託者が作成及び提供した情報の正確性・妥当性・適法性などについて、確認及び保証を求めないこと",
                    },
                  ],
                },
              ],
            },
            {
              title: "第８条（サービスの提供内容）",
              rows: [
                {
                  description:
                    "１．当社は、本サービスを通じてプロジェクトのマッチングを行なうためのツールおよびプラットフォームとして以下のサービスを会員およびクライアントに提供します。",
                  rows: [
                    {
                      description:
                        "(1)相談者が受託者を募集および検索し、マッチングするためのツールまたはサービスの提供",
                    },
                    { description: "(2)マッチングに関する有料サービスの提供" },
                    {
                      description:
                        "(3)その他前各号に付随するツールならびにプラットフォームおよび補助業務（本サービスに必要な通知の送付を含む）の提供",
                    },
                    {
                      description:
                        "(4)当社とクライアントとの間で別途締結する契約に基づく業務の提供",
                    },
                  ],
                },
                {
                  description:
                    "２．本サービスの利用契約は以下の時点で成立するものとし、会員は、利用契約成立日から本規約の適用を受け、当社所定の範囲で本サイトを利用することができるものとします。",
                  rows: [
                    {
                      description:
                        "(1)無料会員：第３条に基づき無料会員として登録が完了した時点",
                    },
                    {
                      description:
                        "(2)有料会員：第４条第５項に基づき当社が有料会員としての登録の通知を発信した時点",
                    },
                  ],
                },
                {
                  description:
                    "３．本条第１項(2)に定める有料サービスには、追加オプションサービス（以下「追加オプション」という）が含まれます。追加オプションの種類、料金額、利用条件その他本規約に定めのない事項については、別途当社が定めるところによるものとします。なお、当該定めは本規約の一部を構成するものとし、利用者はその内容について十分確認し同意したうえで追加オプションを利用するものとします。",
                },
                {
                  description:
                    "４．会員は、本サイトの利用に付随して当社提供の有料サービスを利用する場合、当社所定の方法により申込を行うものとし、当社がこれを承諾したときは当該サービスを利用することができるものとします。なお、この場合、会員は、第１５条に基づき、当該有料サービスに係る当社所定の利用料の支払い義務が発生します。",
                },
                {
                  description:
                    "５．当社は、以下の各号に定める事項を受託者に提供するものとします。",
                  rows: [
                    {
                      description:
                        "(1)受託者がプロフィールを入力・保管するツールまたはサービスの提供",
                    },
                    {
                      description:
                        "(2)受託者が相談者または相談者が募集するプロジェクトを検索および応募し、マッチングするためのツールの提供",
                    },
                    { description: "(3)マッチングに関する有料サービスの提供" },
                    {
                      description:
                        "(4)その他前各号に付随するツールならびにプラットフォームおよび補助業務の提供",
                    },
                  ],
                },
                {
                  description:
                    "６．会員は、本サービスの提供を受けるために必要な情報を本サイトに投稿することができます。",
                },
                {
                  description:
                    "７．利用者は、利用者が本アカウントに対して送信したコンテンツ（以下、「利用者コンテンツ」といいます。）に応じて、本アカウントの自動返答により、本コンテンツの送信を受けることができます。",
                },
              ],
            },
            {
              title: "第９条（表明保証）",
              rows: [
                {
                  description:
                    "１．受託者は、本サービスの利用にあたり、相談者ならびにクライアントおよび当社に対し、以下の事項を表明し保証するものとします。",
                  rows: [
                    {
                      description:
                        "(1)本サービスの利用が、適用法令、規則、行政機関または業界団体等により定められた指針に抵触しないこと。",
                    },
                    {
                      description:
                        "(2)本サービスの利用が、取引先または所属元企業との間における利益相反、秘密保持、競業避止その他就業規則および諸規程等により受託者が負う義務に抵触しないこと。",
                    },
                  ],
                },
                {
                  description:
                    "２．相談者ならびにクライアントおよび受託者は、本サービスを通じたマッチングにより、係争が発生した場合は、全て当事者間で対応し当社は一切の責任を負わないことを認識し、同意するものとします。",
                },
              ],
            },
            {
              title: "第１０条（契約関係）",
              rows: [
                {
                  description:
                    "１．相談者と受託者は、本サービスを通じてマッチングし、両者の間に業務取引が発生する場合、当該取引に関する契約は相談者および受託者との間で成立し、当社が契約当事者ではないことを確認します。なお、この場合、相談者および受託者は別途業務取引に係る契約を締結するものとします。",
                },
                {
                  description:
                    "２．前項の定めにかかわらず、本サイト上のシステムまたはその他の手段を通じて、当社がクライアントと受託者をマッチングした場合、クライアントの業務を当社が受託し受託者に再委託する場合又は当社とクライアント若しくは受託者が合意した場合は、別途人材紹介契約、業務委託契約その他必要な契約を締結するものとします。",
                },
              ],
            },
          ],
        },
        {
          title: "第４章　共通規約",
          articles: [
            {
              title: "第１１条（個人情報の取得およびメッセージ内容の閲覧等）",
              rows: [
                {
                  description:
                    "１．当社が本サービスに伴い取得する個人情報は、個人情報保護法および当社が別途定める個人情報保護方針（ https://crowdworks.co.jp/privacy_policy/ ）の定めに従い、取り扱うものとします。",
                },
                {
                  description:
                    "２．本サービスにおける会員間およびクライアントと受託者との間のメッセージは、適正な利用の促進を目的として、適宜当社がメッセージ内容を閲覧確認することができるものとし、会員およびクライアントは当社が閲覧することを承諾するものとします。",
                },
                {
                  description:
                    "３．当社は、メンション機能を用いて本アカウントのX（旧Twitter）アカウントに対してツイートを送信した利用者がX（旧Twitter）上で一般公開している情報（プロフィール、フォローしている人、フォロワー、ツイート、「いいね」した第三者のツイート等を含みます。以下同じです。）にアクセスする場合があります。利用者は、メンション機能を用いて本アカウントのX（旧Twitter）アカウントに対してツイートを送信した場合、利用者がX（旧Twitter）上で一般公開している情報を当社が取得することに同意したものとみなされます。",
                },
              ],
            },
            {
              title: "第１２条（秘密保持義務）",
              rows: [
                {
                  description:
                    "１．受託者は、本サービスの利用に関して相談者もしくはクライアントおよび当社から取得した一切の情報を秘密として保持し、情報の開示者の書面による事前の同意がない限り、これを第三者に開示または漏洩しないものとします。",
                },
                {
                  description:
                    "２．相談者およびクライアントは、本サービスの利用に関して受託者および当社から取得した受託者個人に関する情報および受託者個人を推測できる情報（以下、「受託者情報」といいます。）を秘密として保持し、受託者の書面による事前の同意がない限り、かかる受託者情報を第三者に開示または漏えいしないものとします。但し、相談者がコーポレーション機能を利用した場合には、同機能を相談者と同一法人内で利用しているメンバーおよび管理者に対してのみ、相談者およびクライアントは受託者情報を共有できるものとします。",
                },
                {
                  description:
                    "３．相談者およびクライアントは、受託者から本サービスを通じて入手した情報（以下「受託者の知見に基づく情報」といい、「受託者情報」は含まれないものとします。）については、別途相談者もしくはクライアントと受託者もしくは当社との間で締結する契約に定めのない限り、受託者から秘密として扱う旨を明示された場合を除き、業務上必要な範囲で特定の第三者に対して提供できます。ただし、相談者およびクライアントは、受託者の知見に基づく情報を、受託者個人の書面（電磁的方法も含む）による事前の同意がある場合を除き、いかなる目的であっても、SNSなど不特定多数に配信されるソーシャルメディアやwebページ等での情報発信の方法により、不特定多数の者に提供してはなりません。",
                },
                {
                  description:
                    "４．前各項に定める秘密保持義務は、会員およびクライアントが退会した後においても、秘密情報が公知のものとして一般利用が可能となるまでの間効力をするものとします。",
                },
              ],
            },
            {
              title: "第１３条（コンプライアンス）",
              rows: [
                {
                  description:
                    "１．受託者は、本サービスを利用するに当たり、常に信義かつ誠実に、本規約ならびに適用法令および規則に従って行動することに同意するものとします。",
                },
                {
                  description:
                    "２．受託者は、以下の各号に定めるいかなる情報も、相談者またはクライアントに共有しないものとします。",
                  rows: [
                    {
                      description:
                        "(1)受託者が第三者に対して守秘義務を負うあらゆる情報",
                    },
                    {
                      description:
                        "(2)過去または現在の雇用主、コンサルティングを提供した会社、その他あらゆる第三者が所有する企業秘密",
                    },
                    {
                      description:
                        "(3)受託者が、現在特定の企業の従業員または取締役である場合、当該企業に関する業績、戦略、業務手順、業務運営または製品等に関する非公開情報",
                    },
                    { description: "(4)法令により開示が禁じられている情報" },
                    {
                      description:
                        "(5)その他、社会通念上、秘密に保持すべきと認められる情報",
                    },
                  ],
                },
                {
                  description:
                    "３．相談者およびクライアントは、前項各号に定める情報および次項に定める業務取引および情報提供を受託者に要求しないものとします。受託者は、万が一相談者またはクライアントから要求された場合、ただちに業務取引および情報提供を中止し、当社に報告するものとします。",
                },
                {
                  description:
                    "４．受託者は以下の各号に定める業務取引を受託してはならないものとします。",
                  rows: [
                    {
                      description:
                        "(1)受託者が、現在特定の企業の従業員または取締役である場合、当該企業の直接競合他社となる相談者へ情報を提供すること",
                    },
                    {
                      description:
                        "(2)受託者が監査人または元監査人である場合、受託者自身、過去もしくは現在の雇用主が現在監査を行っている会社、または過去三年間に監査を行った組織に関する情報を提供すること",
                    },
                    {
                      description:
                        "(3)受託者が弁護士、司法書士または行政書士である場合に、法令で第三者から事件や案件の紹介を禁止される場合に該当する業務",
                    },
                    { description: "(4)有価証券等への投資アドバイス全般" },
                    {
                      description:
                        "(5)受託者が所属する企業の内部規則に違反する恐れがある業務取引および情報提供",
                    },
                    {
                      description:
                        "(6)その他本規約および適用法令ならびに規則に違反する恐れがある業務取引および情報提供",
                    },
                  ],
                },
                {
                  description:
                    "５．受託者は、相談者およびクライアントが自社のコンプライアンス目的で電話会議形式によるインタビューにコンプライアンス担当者を同席させる場合があること並びにメッセージおよびプロフィールの内容が閲覧されることに同意するものとします。",
                },
              ],
            },
            {
              title: "第１４条（利用期間）",
              rows: [
                {
                  description:
                    "１．当社と会員との間で成立する本サイトの利用契約に係る利用期間は、以下のとおりとします。",
                  rows: [
                    {
                      description:
                        "(1)無料会員：第８条第２項(1)に定める無料会員としての利用契約成立日から、第２５条に基づき利用契約が終了する日まで。なお、有料会員が次号に定める有料期間終了後に有料会員としての本サイトの利用契約を更新しない場合、有料期間終了日の翌日から無料会員としての本サイトの利用契約が開始するものとします。",
                    },
                    {
                      description:
                        "(2)有料会員：第２５条に基づき利用契約が終了しない限り、第８条第２項(2)に定める本サイトの有料会員としての利用契約成立日から、有料期間満了日まで。なお、利用期間満了日の１か月前までに当社に終了の通知のない限り、同一の条件で自動的に更新されます。",
                    },
                  ],
                },
                {
                  description:
                    "２．本サイトの利用に係る料金は、有料期間開始日から発生するものとし、相談者は、第１５条に基づき利用料を支払うものとします。",
                },
                {
                  description:
                    "３．会員は、有料サービスについて、有料サービスの利用を当社が承諾した日から当社所定の期間利用することができるものとします。なお、期間満了日の１か月前までに当社に終了の通知のない限り、当該期間が満了した時点で同一の条件で自動的に更新されます。ただし、有料サービスの利用期間中といえども、本サイトの利用契約が終了した場合、当該終了日を以って、有料サービスも終了するものとします。",
                },
                {
                  description:
                    "４．会員は、本条第１項(2)および第３項に基づく契約の更新を拒絶するためには、事前に当社所定の契約終了手続（更新拒絶手続）を行う必要があります。契約終了手続（更新拒絶手続）を怠った結果、契約が自動更新された場合、更新期間に対応する利用料金が発生します。",
                },
                {
                  description:
                    "５．本サイトの利用契約および有料サービスの利用契約は、別段の定めのない限り、中途解約することはできません。会員が契約開始後に本サイトおよび有料サービスの利用を中止する場合であっても、利用料金を返還することはできません。なお、未払いの利用料金がある場合はその全額をお支払いいただきます。",
                },
                {
                  description:
                    "６．前項に違反して、利用料金の返還を求めたり、未払いの利用料金の支払を拒絶したりする会員について、当社は、事前に通知することなく、お客様のデータ、コンテンツ、アカウントを削除し、将来に渡り本サービスの利用を認めないことがあります。",
                },
              ],
            },
            {
              title: "第１５条（支払義務）",
              rows: [
                {
                  description:
                    "１．相談者は、利用契約成立日において、初期費用として当社料金表に定める金額を支払うものとします。当該初期費用は、本サイトの利用契約成立日の属する月の末日で締めて翌月末日までに、当社所定の方法により支払うものとします。",
                },
                {
                  description:
                    "２．相談者は、利用期間中の本サイトの利用にあたり、当社所定の料金表に基づき算出した有料期間の本サイト利用料総額を、本サイトの利用契約成立日の属する月の末日で締めて翌月末日までに、当社所定の方法により支払うものとします。なお、利用料について日割りでの算出は行いません。",
                },
                {
                  description:
                    "３．会員は、有料サービスの利用料について、別途当社と締結する契約に定めのない限り、当社が当該サービスの利用を承諾した日の属する月の末日で締めて翌月末日までに、当社所定の方法により支払うものとします。",
                },
                {
                  description:
                    "４．前３項に基づく支払に係る支払手数料は会員が負担するものとします。",
                },
                {
                  description:
                    "５．会員が本条第１項から第３項までに定める利用料、その他の費用を支払期限までに支払わない場合、当社は、当該支払期限の翌日から支払済みに至るまでの期間について年14.6%の遅延損害金を利用料と合わせて請求することができるものとします。",
                },
                {
                  description:
                    "６．会員が本条第１項から第３項までに定める利用料、その他の費用の支払いを１回でも滞った場合または本規約に定める禁止事項に該当した場合、当社は会員に事前に通知することにより、会員の本サービスの利用に関する一切の債務について期限の利益を失わせることができるものとし、会員はかかる通知を受領したときは、期限の利益を喪失した債務の全額を直ちに弁済するものとします。",
                },
                {
                  description:
                    "７．当社は、法令に基づき回収し、税務当局に対して支払わなければならない税金（消費税を含みますが、これに限られません）を、その時点において適用される税率または税額に応じて、手数料その他の費用に加えて徴収することができます。",
                },
                {
                  description:
                    "８．当社は、会員から利用申込に際して通知された住所地をもって消費税の内外判定を行うものとし、通知され住所地の誤りにより消費税の徴収に問題が発生した場合、会員およびクライアントがその責任を負うものとします。",
                },
                {
                  description:
                    "９．第14条第１項(2)および第３項に基づく契約の更新日より新たな有料サービスの利用料が適用されることを当社が会員に通知した場合、更新日より当該利用料が適用されるものとします。",
                },
              ],
            },
            {
              title: "第１６条（禁止事項）",
              rows: [
                {
                  description:
                    "１．本サービスの会員および利用者は、以下の各号に定める行為を行ってはならないものとします。",
                  rows: [
                    {
                      description: "(1)会員もしくは第三者の権利を侵害する行為",
                    },
                    {
                      description:
                        "ⅰ）個人、法人を問わず、第三者の権利（財産権、知的財産権、著作権、プライバシー権、氏名権、肖像権、名誉等）を侵害する行為",
                    },
                    {
                      description:
                        "ⅱ）企業機密等を漏洩するなど、守秘義務に違反する行為（株価に影響を及ぼす可能性のある重大な非公開情報、臨床検査の治験情報等含むが、それに限られない）",
                    },
                    {
                      description:
                        "ⅲ）所属企業、団体等の内部規則等に違反する行為",
                    },
                    { description: "(2)適切なサービス実施を妨げる行為" },
                    { description: "ⅰ）虚偽の情報を登録・投稿・表示する行為" },
                    {
                      description:
                        "ⅱ）複数アカウントの登録、または自己のアカウントを他人に譲渡または貸与することにより利用させるなど、アカウントを不正に利用する行為",
                    },
                    {
                      description:
                        "ⅲ）当社の書面による事前の同意を得ることなく、本サービスで成立した業務取引に参加する権利を他人に譲渡する行為",
                    },
                    {
                      description:
                        "ⅳ）質問された内容に対して、意図的に虚偽もしくは不誠実な内容を回答する行為",
                    },
                    {
                      description:
                        "ⅴ）本アカウントに対し、過度に暴力的な表現、露骨な性的表現、児童ポルノ・児童虐待に相当する表現、人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現、自殺、自傷行為、薬物乱用を誘引または助長する表現、その他反社会的な内容を含み他人に不快感を与える表現（以下、「不適切表現」といいます。）を送信する行為",
                    },
                    {
                      description:
                        "ⅵ）本アカウントに対し、利用者の要配慮個人情報、第三者のプライバシーに関する情報、利用者が所属する法人等の組織に関する機密情報等を含む機密性の高い情報を送信する行為",
                    },
                    {
                      description:
                        "ⅶ）本アカウントによる第三者の法令上又は契約上の権利（財産権、知的財産権、著作権、プライバシー権、氏名権、肖像権、名誉等を含みます。）を侵害する表現の送信を誘発する行為",
                    },
                    {
                      description:
                        "ⅷ）本アカウントによる不適切表現の送信を誘発する行為",
                    },
                    { description: "(3)当社の業務に支障を与える行為" },
                    {
                      description:
                        "ウイルスの送付、不正アクセス等により、当社システムおよび本サービス提供に障害等を引き起こす行為",
                    },
                    {
                      description:
                        "その他本サービス、当社の業務を妨害、または当社の信頼を毀損する行為",
                    },
                    { description: "(4)本来の目的とは異なる利用" },
                    {
                      description:
                        "ⅰ）政治的または宗教的思想を含む情報を提供、または勧誘する行為（当社が事前に許可した場合を除く）",
                    },
                    {
                      description:
                        "ⅱ）ネットワークビジネス、マルチ商法、ねずみ講に該当する行為またはそれらへの勧誘行為、商品販売もしくは、結婚紹介、出会い系サービスに該当する行為またはそれらなどへの勧誘行為",
                    },
                    {
                      description:
                        "ⅲ）インターネット異性紹介事業を利用して児童を誘引する行為の規制等に関する法律に基づく、当該事業の提供者に対する規制および当該事業を利用した不正勧誘行為の禁止に違反する行為",
                    },
                    {
                      description:
                        "ⅳ）本サイトを利用したアフィリエイト誘導、目的に合致しないリンクの貼付け行為",
                    },
                    {
                      description:
                        "ⅴ）日本における刑法に定める汚職の罪に該当する行為、その他諸外国で定められている汚職腐敗や贈収賄防止法（例えば米国海外汚職腐敗行為防止法、英国贈収賄法など）に定められるような、企業における業務の獲得もしくは維持に便宜を図る目的で不当に金銭や物品の授受を行う行為、もしくは公的立場で行為をする政府関係者の判断や決定等に金銭や物品を提供して不適切な影響を与える行為",
                    },
                    {
                      description:
                        "ⅵ）本サービスの一部もしくは全部の複製・改変・編集・消去・他のプログラム等との結合・リバースエンジニアリング・逆アセンブル・逆コンパイル等またはミラーサイト構築等の行為",
                    },
                    {
                      description:
                        "ⅶ）スクレイピング、クローリング（クローラ、ロボットおよびスパイダー等のプログラム）ならびにその他の類似の手段によって本サービスにアクセスし、本サービスに関する情報を取得する行為",
                    },
                    {
                      description:
                        "ⅷ）法令、公序良俗に反する行為、そのおそれがある行為",
                    },
                    {
                      description:
                        "ⅸ）本サービスと同一または類似するサービスの運営のために本サービスに登録しまたは本サービスに登録された情報等を利用する行為",
                    },
                    {
                      description: "ⅹ）その他当社が不適切であると判断する行為",
                    },
                  ],
                },
                {
                  description:
                    "２．前項に定める禁止行為に該当すると当社が判断した場合、当社は、事前に通知することなく利用停止、禁止行為に該当すると判断された登録情報および利用者間のメッセージの一部削除、会員登録の抹消等次条に規定する処分を含む必要な対応を講じることができるものとします。また、当社、他の会員および第三者に損害が発生した場合、会員は、損害賠償義務を負うものとします。",
                },
              ],
            },
            {
              title: "第１７条（利用停止、会員登録の抹消および剥奪）",
              rows: [
                {
                  description:
                    "１．当社は、会員が以下の各号のいずれかの事由に該当すると判断した場合、当該会員に対して、何ら通知等することなく、本サービスの利用を一時的に停止すること、会員登録を抹消すること、投稿を削除すること、もしくは会員資格を剥奪し以降の一切の利用を禁止することができるものとします。",
                },
                {
                  description:
                    "(1)法令その他公序良俗に反し、または反する恐れがある場合",
                },
                {
                  description:
                    "(2)本規約に違反し、または違反する恐れがある場合",
                },
                {
                  description:
                    "(3)本規約に定める会員としての資格・条件を満たしていないことが判明し、または満たさなくなったと当社が判断した場合",
                },
                {
                  description:
                    "(4)会員が当社の運営するサービスと同一もしくは類似しまたは競合するサービスを運営する会社であると当社が判断する場合",
                },
                {
                  description:
                    "(5)本サービスの運営方針に合致しないと当社が判断する場合",
                },
                {
                  description:
                    "(6)記載情報の不足、矛盾または虚偽記載など実在性に疑義が発生する場合",
                },
                {
                  description:
                    "(7)以前登録を抹消された者、もしくは利用を拒否した者が登録していた場合",
                },
                { description: "(8)当社からの改善等の要請に対応しない場合" },
                {
                  description:
                    "(9)登録された連絡先に当社が連絡したにもかかわらず、相当な期間応答しない場合",
                },
                {
                  description:
                    "(10) 他の会員や第三者から受ける苦情が、当社所定の水準を超えた場合（当該会員について、他の会員や第三者から当社が受ける苦情を含む）",
                },
                {
                  description:
                    "(11)会員により本サービス上に登録・投稿・表示された記載の内容およびその表現方法等について、本サービスの目的に照らして不適切、もしくは目的に反すると当社が判断した場合",
                },
                {
                  description:
                    "(12)その他当社が本サービスの会員としてふさわしくないと判断した場合",
                },
                {
                  description:
                    "２．前項により、会員に損害が発生した場合でも、当社は会員および利用者に対して何らの責任も負いません。",
                },
              ],
            },
            {
              title: "第１８条（サービスの中断、停止または終了）",
              rows: [
                {
                  description:
                    "１．当社は、以下の各号のいずれかの事象が発生した場合、会員および利用者に事前に通知することなく、本サービスの中断もしくは停止、提供内容変更または終了を行うことができるものとします。",
                  rows: [
                    {
                      description:
                        "(1)本サービスに関するシステム保守等の緊急を要するメンテナンスを実施する場合",
                    },
                    {
                      description:
                        "(2)停電、火災および天災等の不可抗力により本サービスが提供できなくなった場合",
                    },
                    { description: "(3)その他当社が必要と判断した場合" },
                  ],
                },
                {
                  description:
                    "２．前項により、会員に損害が発生した場合でも、当社は会員および利用者に対して何らの責任も負いません。",
                },
              ],
            },
            {
              title: "第１９条（当社の不保証）",
              rows: [
                {
                  description:
                    "１．本サービスの利用に関し、当社は、別途クライアントと締結する契約に定める場合を除き、マッチングのみを行うものとし、業務取引に関して一切の責任を負いません。",
                },
                {
                  description:
                    "２．本サービスにて、会員が登録する情報は、会員の責任および判断に基づくものであり、当社は、情報の正確性、適法性および妥当性について、何ら保証をするものではありません。本サービスの利用は、全て利用者自らの責任において行うものとします。",
                },
                {
                  description:
                    "３．当社は、受託者による業務が、第三者の権利を侵害しないことおよび違法性を有しないことを一切保証するものではありません。当社の債務不履行または不法行為による場合を除き、当社は、受託者による業務によって会員が被った損害について、一切補償いたしません。",
                },
                {
                  description:
                    "４．当社は、本サービスにおける個々の内容および品質、受託者の能力および資格、ならびに相談者が求める情報を有するか否かについて、利用者に対して何ら保証をするものではありません。",
                },
                {
                  description:
                    "５．当社は、本サービスに付随して開催するセミナーやブログその他のメディアを通じて紹介する受託者の経歴や保有資格等について、利用者に対して何ら保証をするものではありません。",
                },
                {
                  description:
                    "６．本コンテンツにはAIを利用して生成されたコンテンツ（以下、「AI生成コンテンツ」といいます。）が含まれており、その性質上、確実性、完全性、真実性、正確性、合法性（第三者の知的財産権その他の権利を侵害していないことを含みます。）等について、何ら保証するものではありません。また、当社は、本コンテンツに含まれるいかなる内容についても、それらを是認するものではなく、本コンテンツは、当社の見解又は意見を表明するものではありません。利用者は、本アカウントのみに依拠して意思決定を行うべきではなく、本コンテンツの利用は、全て利用者自らの責任において行うものとします。",
                },
                {
                  description:
                    "７．本コンテンツは、特定の案件に対する具体的な法的アドバイスを目的として提供されるものではありません。",
                },
              ],
            },
            {
              title: "第２０条（権利帰属）",
              rows: [
                {
                  description:
                    "１．本サイトのすべてのコンテンツに係る著作権その他の知的財産権は、別途記載がある場合を除き、全て当社または当社が許諾を受けた権利者に帰属するものとします。",
                },
                {
                  description:
                    "２．本サービスの全ての情報について、当社以外が、当社に無断でこれを利用、転用することはできません。",
                },
                {
                  description:
                    "３．業務取引の過程において発生した成果物（中間成果物を含みます。以下、同じ。）の著作権その他の知的財産権は、当事者間で別途書面による合意がある場合を除き、相談者またはクライアントに帰属するものとします。なお、この場合、会員およびクライアントは、当該成果物の取扱いについて、業務取引に関し別途締結する契約において定めるものとします。",
                },
                {
                  description:
                    "４．相談者または受託者は、当社に対し明示的に拒否した場合を除き、当社が以下を行うことに同意するものとします。",
                  rows: [
                    {
                      description:
                        "(1)マッチングおよびメッセージの内容を記録し、文字に起こすこと。",
                    },
                    {
                      description:
                        "(2)前号に基づき作成した記録または文章を広告宣伝のために利用すること。",
                    },
                    {
                      description:
                        "(3)事前の通知により、広告宣伝のため、相談者または受託者のロゴを使用すること。",
                    },
                  ],
                },
                {
                  description:
                    "５．本コンテンツに関する知的財産権は、当社又は正当な権利を有する第三者に帰属します。利用者は、本規約に違反しない範囲内で本コンテンツを利用することができますが、①本コンテンツにはAI生成コンテンツが含まれること、②AI生成コンテンツには第三者の著作物が含まれる可能性があること、及び、③第三者の著作物を著作権法で認められた私的使用目的での利用等以外の方法で利用する場合には著作権者の許諾を受ける必要があることに留意する必要があります。",
                },
                {
                  description:
                    "６．利用者は、利用者コンテンツに関して知的財産権を有する場合、当該権利を従前どおり保持します。ただし、利用者コンテンツのうち、SNS等を通じて一般公開（不特定多数の人が閲覧可能な状態に置くことをいいます。以下同じです。）されたものに限り、利用者は、当社に対し、当該利用者コンテンツ及び当該SNS等の投稿内容を本サービスのプロモーションに利用する権利（当社が必要かつ適正とみなす範囲で省略等の変更を加える権利及び当社と提携する第三者に再許諾する権利を含みます。）を許諾したことになります。",
                },
                {
                  description:
                    "７．利用者は、利用者コンテンツに関する著作者人格権等の権利を、前項に基づく当社又は第三者による利用に対して行使しないものとします。",
                },
                {
                  description:
                    "８． 当社は、利用者による本サービスの利用状況その他利用者による本サービスの利用に関して当社が取得する情報を、本サービスその他当社が提供するサービスの提供、維持及び改善、当社における新サービスの企画開発並びに本サービスその他当社が提供するサービス上での広告配信の目的で、分析、解析その他の方法による利用をすることができるものとします。",
                },
              ],
            },
            {
              title: "第２１条（事例の公開）",
              rows: [
                {
                  description:
                    "１．当社は、相談者または受託者から特段の申し入れのない限り、相談者または受託者の会社名及び相談者または受託者へのインタビューにより取得した情報を、当社導入事例として当社ウェブサイト又は営業資料等において公開できるものとします。なお、相談者及び受託者は、当社より本サービスの利用に関するインタビューの要請があった場合、これを不合理に拒絶しないものとします。",
                },
                {
                  description:
                    "２．相談者及び受託者は、前項に基づき事例を公開する場合に必要な範囲内でのロゴ及び商標等の使用を当社に無償で許諾するものとします。",
                },
              ],
            },
            {
              title: "第２２条（本サービスの譲渡）",
              rows: [
                {
                  description:
                    "当社は、本サービスの事業を第三者に譲渡した場合、当該事業譲渡に伴い、本サービスの運営者たる地位、本利用規約上の地位、本利用規約に基づく権利及び義務並びに会員の登録情報及びその他情報を当該事業譲渡の譲受人に譲渡することができるものとし、本サービスの会員は、会員たる地位、本規約上の地位、本利用規約に基づく権利及び義務並びに会員の登録情報その他情報の譲渡につきあらかじめ同意するものとします。なお、本条に定める事業譲渡には、事業譲渡のみならず、会社分割その他企業再編行為により事業が移転するあらゆる場合を含みます。",
                },
              ],
            },
            {
              title: "第２３条 （地位等の譲渡禁止）",
              rows: [
                {
                  description:
                    "会員およびクライアントは、本規約に基づく権利、義務及び本規約の契約上の地位の全部又は一部について、これを第三者に譲渡、質入れ、その他の方法により処分してはならないものとします。但し、弊社の書面による事前の承諾がある場合を除きます。",
                },
              ],
            },
            {
              title: "第２４条（免責事項および損害賠償）",
              rows: [
                {
                  description:
                    "１．当社の債務不履行または不法行為による場合を除き、当社は、以下の各号の事項に伴い発生した不利益、損害等について、理由の如何を問わず、一切の責任を負わないものとします。",
                  rows: [
                    {
                      description:
                        "(1)本サービスを通じた会員の投稿、会員間のやりとりを含め、会員間、会員もしくは利用者と第三者の間でトラブルが発生した場合",
                    },
                    {
                      description:
                        "(2)本サービスを通じて入手した役務、情報が利用者の期待を満たさなかった場合",
                    },
                    {
                      description:
                        "(3)本サービスからリンクされた当社以外のサイト利用に伴うトラブルが発生した場合",
                    },
                    {
                      description:
                        "(4)本サービスの登録・投稿等のデータが消失した場合",
                    },
                    {
                      description:
                        "(5)本サイト、当社システムへの不正アクセス、コンピューターウイルスの混入等が発生した場合",
                    },
                    {
                      description:
                        "(6)当社から送付されるメール、本サイトにコンピューターウイルス等有害なものが含まれていた場合",
                    },
                    { description: "(7)本サービスが中断、停止、終了した場合" },
                    {
                      description:
                        "(8)本規約に基づく利用停止等の対応により、当該利用者が損害を被った場合",
                    },
                    {
                      description:
                        "(9)外部サービス（ChatGPT、LINE、Twitterを含みますが、これらに限られません。）に関連して利用者が損害を被った場合",
                    },
                  ],
                },
                {
                  description:
                    "２．当社の債務不履行または不法行為に基づいて利用者に損害が発生した場合、当社に故意または重過失があるときを除き、当社は、当該利用者が現実に発生した直接被った通常損害について、当該利用者が当社に支払った金額の総額を上限として損害賠償責任を負うものとします。",
                },
              ],
            },
            {
              title: "第２５条（解約および退会）",
              rows: [
                {
                  description:
                    "１．有料会員および有料サービスの利用者は、第１４条第１項(2)に定める利用期間中、別段の定めのない限り、本サイトおよび有料サービスの利用契約を中途解約することはできません。なお、有料会員または有料サービスの利用社が利用契約成立日以降に本サイトまたは有料サービスの利用を中止する場合であっても、当社は、有料期間に係る利用料を返還することはできず、未払いの利用料がある場合はその全額をお支払いいただきます。",
                },
                {
                  description:
                    "２．前項の定めにかかわらず、有料会員および有料サービスの利用者は、当社所定の手続きにより、有料期間に係る利用料総額および有料サービスの料金の支払を条件として利用契約の終了を求めることができるものとします。",
                },
                {
                  description:
                    "３．無料会員は、無料会員としての利用契約の終了（以下「退会」という）を希望する場合、当社所定の手続きにより通知を行うものとします。なお、この場合、会員は、退会日以降、本サイトの閲覧を含み一切の利用ができないことに同意するものとします。",
                },
                {
                  description:
                    "４．本条に違反して、会員が利用料金の返還を求めまたは未払いの利用料金の支払を拒絶する場合、当社は、事前に通知することなく、当該会員のデータ、コンテンツ、アカウントを削除し、将来に渡り本サービスの利用を認めないことがあります。",
                },
              ],
            },
            {
              title: "第２６条（存続条項）",
              rows: [
                {
                  description:
                    "１．本サービスに係る契約が終了（解除または解約による終了を含みます。以下、同じ。）した場合においても、第９条（表明保証）、第１１条（個人情報の取得およびメッセージ内容の閲覧）、第１２条（秘密保持義務）、第１５条（支払義務）、第１７条（利用停止、会員登録の抹消および剥奪）第２項、第１８条（サービスの中断、停止または終了）第２項、第１９条（当社の不保証）、第２０条（権利帰属）、第２１条（事例の公開）、第２２条（本サービスの譲渡）、第２３条（地位等の譲渡禁止）、第２４条（免責事項および損害賠償）、第２６条（存続条項）および第３０条（準拠法・管轄合意）の規定はなお有効に存続するものとします。",
                },
                {
                  description:
                    "２．本サービスに係る契約が終了した場合、すでに成立している業務取引の取り扱いについては、当該業務取引に係る契約の当事者において協議するものとします。",
                },
              ],
            },
            {
              title: "第２７条（分離可能性）",
              rows: [
                {
                  description:
                    "１．本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、その残部は有効とします。また、無効または執行不能と判断された条項もしくは部分についても、当該条項もしくは部分の趣旨に最も近い有効な条項を無効または執行不能な条項もしくは部分と置き換えて適用し、または当該条項もしくは部分の趣旨に最も近い有効な条項となるよう合理的な解釈を加えて適用します。",
                },
                {
                  description:
                    "２．本規約の規定の一部がある利用者との関係で無効とされ、または取り消された場合でも、本規約はその他の利用者との関係では有効とします。",
                },
              ],
            },
            {
              title: "第２８条（反社会的勢力に所属しないこと）",
              rows: [
                {
                  description:
                    "１．当社及び会員、クライアントは、相手方に対し、自己およびその代表者、役員、その他、実質的に経営を有する者が、現在、暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団、これらの者と密接な関係を有する者またはこれらに準じる者のいずれにも該当しないことを表明し、かつ、将来にわたっても該当しないことを確約するものとします。",
                },
                {
                  description:
                    "２．当社は、会員またはクライアントが前項に違反しまたは違反している恐れがあると判断した場合、会員またはクライアントに通知することなく、本サービスに係る契約を解除することができるものとします。",
                },
                {
                  description:
                    "３．前項の場合において、当社は会員またはクライアントに対し損害賠償を含め一切の責任を負いません。",
                },
              ],
            },
            {
              title: "第２９条（変更可能性）",
              rows: [
                {
                  description:
                    "本規約は当社の裁量により、事前の予告なく随時変更することができるものとし、変更後の規約は本サイト上に掲載された時点から効力が生ずるものとします。また、変更後の規約が本サイト上に掲載された後に本サイトの閲覧を含み利用した利用者は、変更後の規約に同意したものとみなされます。",
                },
              ],
            },
            {
              title: "第３０条（準拠法・管轄合意）",
              rows: [
                {
                  description: "本規約は日本法に基づき解釈されるものとします。",
                },
                {
                  description:
                    "本サービスまたは本規約に関連して生じた一切の紛争については、訴額に応じて、東京簡易裁判所または東京地方裁判所を第一審の専属的合意管轄裁判所とします。",
                },
              ],
            },
          ],
        },
      ]
    },
  },
})
